import { ApplicationManifest } from '@getvim-os/types';
import { SdkLogger } from '@getvim/dynamic-vim-os-sdk';
import { CommonVimSDK, InternalResourceUpdater } from '@getvim/dynamic-vim-os-sdk/sdk';
import {
  AppToOSMessageTypes,
  EnableLaunchButtonPayload,
  HandshakePayload,
  TrackPayload,
} from '@getvim/vim-os-api';
import { GENERIC_SDK } from '@getvim/vim-os-sdk-api';
import 'reflect-metadata';
import { AppEhrState } from '../types';
import { EhrActionsDispatcher } from './ehrActions';
import { EhrEventsApi } from './ehrEventsApi';
import { InternalOsCommunicator } from './internalOsCommunicator';
import { InternalSessionContext, InternalSessionContextApi } from './internalSessionContextApi';
import { LaunchButtonApi } from './launchButtonApi';
import { OsToInternalAppEhrConvertor } from './osToInternalAppEhrConvertor';
import { SharedServiceApi } from './sharedServiceApi';
import { VimEventTarget } from './vimEventTarget';

type EHR_STATE = AppEhrState<{ withPII: true }>;

export class InternalVimSDK extends CommonVimSDK<EHR_STATE> implements GENERIC_SDK<EHR_STATE> {
  constructor(
    payload: HandshakePayload,
    osMessageChannel: MessageChannel,
    logger: SdkLogger,
    tokensResponse?: { idToken: string },
  ) {
    const osCommunicator = new InternalOsCommunicator(payload, osMessageChannel, logger);
    super({
      payload,
      osMessageChannel,
      oSToAppEhrConvertor: new OsToInternalAppEhrConvertor(),
      osCommunicator,
      logger,
    });
    const incomingOsMessagePort = osMessageChannel.port1;
    this.manifestSupport = payload.manifestSupport;
    this.deviceId = payload.deviceId;
    this.bareboneType = payload.bareboneType;
    this.bareboneVersion = payload.bareboneVersion;
    this.hostname = payload.hostname;
    this.internalEvents = new EventTarget() as unknown as VimEventTarget;
    this.sessionContext = new InternalSessionContextApi(
      payload,
      incomingOsMessagePort,
      this.internalEvents,
      tokensResponse,
    );
    this.sharedService = new SharedServiceApi(incomingOsMessagePort, this.internalEvents);
    this.ehrEvents = new EhrEventsApi(incomingOsMessagePort, this.internalEvents);
    this.launchButton = new LaunchButtonApi(osCommunicator, incomingOsMessagePort);
    this.ehrActions = new EhrActionsDispatcher(osCommunicator, payload.manifestSupport);
    this.internalResourceUpdater = new InternalResourceUpdater(
      osMessageChannel.port1,
      osCommunicator,
      logger,
    );
    this.trackAnalytics = (payload: TrackPayload) => {
      osCommunicator.sendMessageToOS({
        type: AppToOSMessageTypes.TRACK_ANALYTICS,
        payload,
      });
    };
    this.enableLaunchButtons = (enabledLaunchButtons: EnableLaunchButtonPayload) => {
      osCommunicator.sendMessageToOS({
        type: AppToOSMessageTypes.ENABLE_LAUNCH_BUTTONS,
        payload: enabledLaunchButtons,
      });
    };
  }
  public trackAnalytics: (payload: TrackPayload) => void;
  public manifestSupport: ApplicationManifest;

  public internalResourceUpdater: InternalResourceUpdater;
  public internalEvents: VimEventTarget;
  public ehrActions: EhrActionsDispatcher;
  public sharedService: SharedServiceApi;
  public ehrEvents: EhrEventsApi;
  public launchButton: LaunchButtonApi;
  public declare sessionContext: InternalSessionContext;
  /**
   * @deprecated use launchButton instead
   */
  public enableLaunchButtons: (enabledLaunchButtons: EnableLaunchButtonPayload) => void;
  public deviceId: string;
  public bareboneType: string;
  public bareboneVersion: string;
  public hostname?: string;
}
